import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded, getVal } from 'react-redux-firebase';

import './JobTagManager.css';

import { toast } from 'react-toastify';
import LoadingSpinner from 'components/global/LoadingSpinner/LoadingSpinner';
import FormField from '../../contentform/FormField/FormField';

class JobTagManager extends React.Component {
  static propTypes = {
    mode: PropTypes.string,
    tags: PropTypes.object,
    jobs: PropTypes.array
  };

  state = {
    newTag: '',
    _tagsExpanded: {}
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleUploadTag = () => {
    const { mode } = this.props;
    const tagRef = `/tagJob${mode[0].toUpperCase() + mode.slice(1)}Index/${this.state.newTag}`;
    this.props.firebase.set(tagRef, true)
      .then(() => {
        toast.success('Tag successfully added');
        this.setState({ newTag: '' });
      })
      .catch((error) => toast.error('ERROR: ' + error.message));
  }

  handleDeleteTag = (tag) => {
    const { mode } = this.props;
    if (this._renderJobCount(tag) > 0) {
      toast.error('Error: Jobs exist with tag. Please change the tag for these jobs.');
    } else {
      const tagRef = `/tagJob${mode[0].toUpperCase() + mode.slice(1)}Index/${tag}`;
      this.props.firebase.remove(tagRef)
        .then(() => toast.success('Tag successfully deleted'))
        .catch((error) => toast.error('ERROR: ' + error.message));
    }
  }

  handleToggleTagExpand = (tag) => {
    const value = this.state._tagsExpanded[tag] !== undefined ? !this.state._tagsExpanded[tag] : true; 
    this.setState({ _tagsExpanded: { ...this.state._tagsExpanded, [tag]: value } });
  }

  _renderTagListItem = () => {
    const { tags } = this.props;

    return (
      Object.keys(tags).map(tag => (
        <div key={`tag-${tag}`} className='JobTagManager-tag'>
          <div className='JobTagManager-tag-title'>
            <div className='JobTagManager-tag-title-text' onClick={() => this.handleToggleTagExpand(tag)}>
              <h2>{tag}</h2>
              <p>Jobs: {this._renderJobCount(tag)}</p>
            </div>
            <button className='JobTagManager-tag-delete' onClick={() => this.handleDeleteTag(tag)}>
              <i className='fa fa-trash-o' />
            </button>
          </div>
          {
            this.state._tagsExpanded[tag] &&
            <div className='JobTagManager-tag-jobs'>
              {this._renderTaggedJobs(tag)}
            </div>
          }
        </div>
      ))
    );
  }

  _renderJobCount = (tag) => {
    const { mode, tags, jobs } = this.props;
    if (tag === 'u') {
      let count = jobs.length;
      Object.keys(tags).forEach(tag => {
        count -= this._renderJobCount(tag);
      });
      return count;
    }
    const filtered = jobs.filter(job => job.value[mode] === tag);
    return filtered.length;
  }

  _renderTaggedJobs = (tag) => {
    const { mode, tags, jobs } = this.props;
    let filtered = [];
    if (tag === 'u') {
      jobs.forEach(job => {
        if (Object.keys(tags).indexOf(job.value[mode]) === -1) {
          filtered.push(job);
        }
      });
    } else {
      filtered = jobs.filter(job => job.value[mode] === tag);
    }
    return (
      filtered.map(job => (
        <Link key={`link-${job.key}`} to={`/jobform?company=${job.key}`}>
          <span>{`${(job.value.company || 'Unnamed Company')} - ${(job.value.title || 'Untitled Job')}`}</span>
          <span> | {job.value.datePublished ? 'Published' : 'Draft'}</span>
        </Link>
      ))
    );
  }

  render() {
    const { tags, jobs } = this.props;

    return (
      <div className='JobTagManager-root'>
        <FormField
          type='text'
          name='newTag'
          title=''
          subtitle='Add a new tag'
          value={this.state.newTag}
          buttonText='SUBMIT'
          buttonIcon='fa-upload'
          buttonDisabled={isLoaded(tags) && Object.keys(tags).indexOf(this.state.newTag) !== -1}
          errorCode={isLoaded(tags) && Object.keys(tags).indexOf(this.state.newTag) !== -1 ? 'duplicate-tag' : null}
          onChange={this.handleInputChange}
          onButtonClick={this.handleUploadTag}
        />
        {
          !isLoaded(tags) || !isLoaded(jobs) ? 
          <div className='JobTagManager-loadingContainer'>
            <LoadingSpinner />
          </div> :
          <div className='JobTagManager-list'>
            {this._renderTagListItem()}
            {
              this._renderJobCount('u') > 0 &&
              <div className='JobTagManager-tag'>
                <div className='JobTagManager-tag-title'>
                  <div className='JobTagManager-tag-title-text' onClick={() => this.handleToggleTagExpand('u')}>
                    <h2 className='JobTagManager-tag-title-text-error'>Unknown</h2>
                    <p>Jobs: {this._renderJobCount('u')}</p>
                  </div>
                  <button className='JobTagManager-tag-delete'>
                    <i className='fa fa-trash-o' />
                  </button>
                </div>
                {
                  this.state._tagsExpanded['u'] &&
                  <div className='JobTagManager-tag-jobs'>
                    {this._renderTaggedJobs('u')}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

const connectedJobTagManager = connect(
  (state, ownProps) => ({
    tags: getVal(state.firebase.data, `/tagJob${ownProps.mode[0].toUpperCase() + ownProps.mode.slice(1)}Index`),
    jobs: state.firebase.ordered.jobIndex
  })
)(JobTagManager);

const wrappedJobTagManager = firebaseConnect(
  (props) => ([
    { path: `/tagJob${props.mode[0].toUpperCase() + props.mode.slice(1)}Index` },
    { path: '/jobIndex' }
  ])
)(connectedJobTagManager);

export default wrappedJobTagManager;



// WEBPACK FOOTER //
// ./src/components/jobs/JobTagManager/JobTagManager.js